import { useTranslation } from 'react-i18next';

import { AlertSection } from 'components/Display/Alert';
import { Alert } from 'components/Display/Alert/Alert';
import { LoadingSpinner } from 'components/Loading/LoadingSpinner';

export const ValidationPendingBanner = () => {
  const { t } = useTranslation();

  return (
    <Alert withoutIcon severity="warning" fullWidth>
      <div className="flex w-full items-center justify-between gap-6">
        <AlertSection severity="warning" title={t('webedi:viewDocument.validationPending.title')}>
          {t('webedi:viewDocument.validationPending.description')}
        </AlertSection>
        <div className="flex shrink-0 items-center gap-1">
          <LoadingSpinner variant="warning" sizeClassName="size-5" />
          <span className="text-xs font-medium text-amber-700">{t('webedi:viewDocument.validationPending.badge')}</span>
        </div>
      </div>
    </Alert>
  );
};
